import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { BankAccountStatusTypes, PlaidBankAccountStatusTypes } from './payment-method';
export var RelationshipFundingSourceType = /*#__PURE__*/ function(RelationshipFundingSourceType) {
    RelationshipFundingSourceType["CreditCard"] = "creditCard";
    RelationshipFundingSourceType["BankAccount"] = "ach";
    return RelationshipFundingSourceType;
}({});
export var FundingSourceActiveStatus = /*#__PURE__*/ function(FundingSourceActiveStatus) {
    FundingSourceActiveStatus["Active"] = "active";
    FundingSourceActiveStatus["Inactive"] = "inactive";
    return FundingSourceActiveStatus;
}({});
export class RelationshipFundingSourceModel {
    id() {
        return this.dto.id;
    }
    isCreditCard() {
        return this.dto.type === "creditCard";
    }
    isPlaidVerification() {
        return this.dto.type === "ach" && this.dto.ach.status === BankAccountStatusTypes.PlaidVerification;
    }
    isPendingAutomaticVerification() {
        return this.dto.type === "ach" && this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingAutomaticVerification;
    }
    last4() {
        return this.dto ? this.dto.last4 : null;
    }
    isPendingMicroDeposit() {
        return this.dto.type === "ach" && (this.dto.ach.status === BankAccountStatusTypes.New || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingManualVerification || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingAutomaticVerification);
    }
    failedVerification() {
        return this.dto.type === "ach" && (this.dto.ach.status === BankAccountStatusTypes.TwoAttemptsFailed || this.dto.ach.status === BankAccountStatusTypes.VerificationFailed || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.VerificationFailed || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.VerificationExpired);
    }
    isVerified() {
        return this.dto.type === "ach" && this.dto.ach.status === BankAccountStatusTypes.Verified;
    }
    canCompleteVerification() {
        return this.dto.type === "ach" && (this.dto.ach.status === BankAccountStatusTypes.New || this.dto.ach.plaidVerificationStatus === PlaidBankAccountStatusTypes.PendingManualVerification);
    }
    setPlaidVerificationStatus(plaidVerificationStatus) {
        if (this.dto.type === "creditCard") {
            return this;
        }
        return new RelationshipFundingSourceModel(_object_spread_props(_object_spread({}, this.dto), {
            ach: _object_spread_props(_object_spread({}, this.dto.ach), {
                plaidVerificationStatus
            })
        }));
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
